import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/verwaltung/{-$adminLevelId}/meldungen/')({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteComponent,
});

function RouteComponent() {
  return null;
}
